import api from './axiosInstance';
import type {
  UserActivity,
  UserActivityFilterParams,
  UserActivityListResponse,
  UserActivityType,
} from '../types/userActivity';

interface ActivityApiResponse {
  success: boolean;
  message: string;
  data: UserActivity[];
  pagination: {
    page: number;
    limit: number;
    totalDocs: number;
    totalPages: number;
  };
}

export const userActivityService = {
  getUserActivity: async (
    userId: string,
    params?: UserActivityFilterParams
  ): Promise<UserActivityListResponse> => {
    const response = await api.get<ActivityApiResponse>(`/users/${userId}/activity`, { params });
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to fetch user activity');
    }
    return {
      data: response.data.data,
      pagination: response.data.pagination,
    };
  },

  logActivity: async (
    type: 'page_view' | 'action' | 'session_start',
    metadata?: { path?: string; description?: string; entityId?: string; entityType?: string }
  ): Promise<void> => {
    await api.post('/users/me/activity', { type, metadata: metadata ?? {} });
  },
};
